/**
 * PageHeader — Shared eyebrow + title + lead for inner pages.
 */
import React from 'react';
import styles from './PageHeader.module.css';

function PageHeader({ eyebrow, title, lead }) {
  return (
    <header className={styles.header}>
      {eyebrow && <p className="roar-eyebrow">{eyebrow}</p>}
      <h1 className={styles.title}>{title}</h1>
      {lead && <p className={styles.lead}>{lead}</p>}
    </header>
  );
}

export default PageHeader;
